import { render, staticRenderFns } from "./InactiveUsers.vue?vue&type=template&id=deea5040&"
import script from "./InactiveUsers.vue?vue&type=script&lang=js&"
export * from "./InactiveUsers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports